import React from 'react';

import type { IOSNativeProps } from '@react-native-community/datetimepicker';

const DateTimePicker: React.FC<IOSNativeProps> = () => null;

export default DateTimePicker;
export type { DateTimePickerEvent } from '@react-native-community/datetimepicker';
